module.exports = __webpack_public_path__ + "img/M-6.40960165.png";